import { render } from "./MAHistoryPanel.vue?vue&type=template&id=aca385b2"
import script from "./MAHistoryPanel.vue?vue&type=script&lang=ts"
export * from "./MAHistoryPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script